import {
  SAVE_PP_ACCEPT_ERROR,
  SAVE_PP_ACCEPT_IN_PROGRESS,
  SAVE_PP_ACCEPT_SUCCESS
} from "../actions/privacyPolicy.action";

const initialState = {
  accepted: false,
  saveState: null,
  error: null
};

const privacyPolicyReducer = (state = initialState, action) => {
  let newState = {};
  switch (action.type) {
    default: {
      newState = { ...state };
      break;
    }
    case SAVE_PP_ACCEPT_IN_PROGRESS: {
      newState = {
        ...state,
        saveState: SAVE_PP_ACCEPT_IN_PROGRESS,
        error: null
      };
      break;
    }
    case SAVE_PP_ACCEPT_SUCCESS: {
      newState = {
        ...state,
        ...action.payload,
        saveState: SAVE_PP_ACCEPT_SUCCESS,
        error: null
      };
      break;
    }
    case SAVE_PP_ACCEPT_ERROR: {
      newState = {
        ...state,
        saveState: SAVE_PP_ACCEPT_ERROR,
        error: action.error
      };
      break;
    }
  }

  return newState;
};

export default privacyPolicyReducer;
